import { createAction } from '@reduxjs/toolkit';
import { updateTabsCount } from './globalSlice';

// Action type for dispatching to a specific tab
export const TAB_ACTION = 'tabs/tabAction';

// Create a tab-scoped action that wraps any existing action
export const createTabAction = createAction(TAB_ACTION, (tabId, action) => ({
  payload: {
    tabId,
    action,
  },
}));

// Helper function to dispatch an action to a specific tab
// Usage: dispatch(dispatchToTab('tab-1', setFeed_Dict(data)))
export const dispatchToTab = (tabId, action) => createTabAction(tabId, action);

// Helper function to dispatch an action to the active tab
// This requires middleware to resolve the active tab ID
export const dispatchToActiveTab = (action) => ({
  type: 'tabs/activeTabAction',
  payload: { action },
});

// Middleware to handle tab-scoped actions
export const tabMiddleware = (store) => (next) => (action) => {
  // Handle dispatching to active tab
  if (action.type === 'tabs/activeTabAction') {
    const state = store.getState();
    const { activeTabId } = state.tabs;

    // Dispatch the actual tab action - no tracking to avoid cascading updates
    return next(createTabAction(activeTabId, action.payload.action));
  }

  // Handle explicit tab actions - process without tracking to avoid loops
  if (action.type === TAB_ACTION) {
    return next(action);
  }

  // Handle tab creation/removal to update global count
  if (action.type === 'tabs/createTab' || action.type === 'tabs/removeTab') {
    const result = next(action);
    const state = store.getState();
    store.dispatch(updateTabsCount(state.tabs.tabOrder.length));
    return result;
  }

  return next(action);
};

// Custom hook helpers for components
// Usage in components:
// const dispatch = useDispatch();
// dispatch(dispatchToActiveTab(setFeed_Dict(data)));
// OR
// dispatch(dispatchToTab('tab-2', setFeed_Dict(feedData)));
